export function toggleActionMenu(open) {
  return {
    type: 'TOGGLE_ACTION_MENU',
    open,
  }
}